<style scoped>
.caption {
  position: relative;
  float: right;
  line-height: 38px;
  padding-left: 1.2rem;
  margin-left: 1rem;
}

.caption-bullet {
  position: absolute;
  top: .6rem;
  left: 0;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #dee2e6;
  border-radius: 5px;
}

.captions--warning {
  padding-right: 1rem;
}
.captions--warning small {
  color: #dc3545;
  margin-left: auto;
}
</style>

<template>
  <div class="captions-container">
    <b-row>
      <b-col>
        <div
          class="caption"
          v-for="caption in captions"
          v-bind:key="caption.text"
        >
        <span
            class="caption-bullet"
            :style="`background-color: ${caption.background}`"
          />
          {{ caption.text }}
        </div>
      </b-col>
    </b-row>
    <b-row class="captions--warning">
      <small>
        * Documents listed below may not be required at this time, but may be in the future.
      </small>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'documents-legend',
  props: {
    captions: {
      type: Array,
      default: () => [
        { text: 'Reviewed - Approved', background: '#28a745' },
        { text: 'Submitted Files', background: '#6c757d' },
        { text: 'Needed Files', background: '#dc3545' },
      ],
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/utils/DocumentsLegend.vue